import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AssociateClient } from '@core/util/client';
import { PersonClient } from '@models/clients';
import { CollectionPaths } from '@models/collections';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { UserProfileState } from '@state/user-profile';
import { Observable, of } from 'rxjs';
import { Repo } from '../repo.service';

@Injectable({
	providedIn: 'root',
})
export class ClientsRepoService extends Repo<
	PersonClient,
	Record<string, unknown>
> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;

	GetCollectionPath(): string {
		return CollectionPaths.business_clients(this.businessId);
	}

	constructor(private db: AngularFirestore) {
		super(db);
	}

	clientsByIds(ids: string[]): Observable<AssociateClient[]> {
		if (ids?.length) {
			return this.All({}, (q) => q.where('id', 'in', ids)) as Observable<
				AssociateClient[]
			>;
		}

		return of([]);
	}

	clientsExportedToLeap(): Observable<AssociateClient[]> {
		return this.All({}, (q) => q.where('leap', '!=', null)) as Observable<
			AssociateClient[]
		>;
	}
}
